module.exports = __webpack_public_path__ + "img/bookjoy_logo.ecaf2150.svg";